var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.202,
    height: 18.138,
    viewBox: "0 0 20.202 18.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs_down_icon",
    "data-name": "thumbs down icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M3.21,10.2h.831c.475,0,.935.49,1.277.831,1.529,1.455,2.643,4.32,3.133,5.063a.845.845,0,0,0,.683.3,1.2,1.2,0,0,0,.238-.015c1.782-.416,1.054-3.266.386-4.692-.089-.178-.3-.579-.3-.594a.445.445,0,0,1,.4-.564c.579-.045.861-.03,2.108-.03h3.771a1.284,1.284,0,0,0,0-2.568H14.3M12.385,2.818h1.425a1.284,1.284,0,0,0,0-2.568H8.2a5.836,5.836,0,0,0-2.776.7c-.1.059-.223.119-.327.178a2.691,2.691,0,0,1-1.262.312H3.24",
    transform: "translate(1.185 -0.25)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    d: "M10.231,5.946h1.433a1.28,1.28,0,1,1,0,2.56H10.231",
    transform: "translate(4.588 -0.824)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    "data-name": "Path 4357",
    d: "M9.868,7.67H11.3a1.28,1.28,0,1,1,0,2.56H9.868",
    transform: "translate(4.412 -5.107)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M4.689,13.341V5.116a.723.723,0,0,0-.015-.178A1.359,1.359,0,0,0,3.338,3.75H1.616A1.362,1.362,0,0,0,.25,5.116v8.225a1.35,1.35,0,0,0,1.366,1.351H3.338A1.354,1.354,0,0,0,4.645,13.7,1.464,1.464,0,0,0,4.689,13.341Z",
    transform: "translate(-0.25 -3.75)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownDark);
export default __webpack_public_path__ + "static/media/ThumbsDown-Dark.f60467313a4ae06787a7970b563f4b49.svg";
export { ForwardRef as ReactComponent };